import css from './Loader.module.css';

const Loader = () => {
  return (
    <div id={css['load']}>
      <div>G</div>
      <div>N</div>
      <div>I</div>
      <div>D</div>
      <div>A</div>
      <div>O</div>
      <div>L</div>
    </div>
  );
};

export default Loader;
